import operationWorkflowService from "@/services/operations/operationWorkflowService";
import operationLocalDbService from "@/services/operations/operationLocalDbService";

const INITIAL_STATE = {
  operationWorkflows: [
    // {
    //   "ao_enterprise_id": "string",
    //   "ao_enterprise_workflow_forms": [
    //     {
    //       "created_at": "2024-03-22T11:11:13.339Z",
    //       "form_id": "string",
    //       "id": "string",
    //       "name": "string",
    //       "sort_order": 0,
    //       "updated_at": "2024-03-22T11:11:13.339Z"
    //     }
    //   ],
    //   "ao_enterprise_workflow_statuses": [
    //     {
    //       "ao_enterprise_workflow_status_accounts": [
    //         {
    //           "account_id": "string",
    //           "created_at": "2024-03-22T11:11:13.339Z",
    //           "deletable": true,
    //           "id": "string",
    //           "updated_at": "2024-03-22T11:11:13.339Z"
    //         }
    //       ],
    //       "ao_enterprise_workflow_status_forms": [
    //         {
    //           "ao_enterprise_workflow_status_form_accounts": [
    //             {
    //               "account_id": "string",
    //               "created_at": "2024-03-22T11:11:13.339Z",
    //               "id": "string",
    //               "updatable": true,
    //               "updated_at": "2024-03-22T11:11:13.339Z"
    //             }
    //           ],
    //           "ao_enterprise_workflows_form_id": "string",
    //           "ao_enterprise_workflows_status_id": "string",
    //           "created_at": "2024-03-22T11:11:13.339Z",
    //           "id": "string",
    //           "updated_at": "2024-03-22T11:11:13.339Z"
    //         }
    //       ],
    //       "created_at": "2024-03-22T11:11:13.339Z",
    //       "id": "string",
    //       "updated_at": "2024-03-22T11:11:13.339Z",
    //       "workflow_status_id": "string"
    //     }
    //   ],
    //   "ao_enterprise_workflow_transactions": [
    //     {
    //       "ao_enterprise_workflow_transaction_accounts": [
    //         {
    //           "account_id": "string",
    //           "created_at": "2024-03-22T11:11:13.339Z",
    //           "id": "string",
    //           "updated_at": "2024-03-22T11:11:13.339Z"
    //         }
    //       ],
    //       "created_at": "2024-03-22T11:11:13.339Z",
    //       "id": "string",
    //       "updated_at": "2024-03-22T11:11:13.339Z",
    //       "workflow_transaction_id": "string"
    //     }
    //   ],
    //   "ao_enterprise_workflow_vessels": [
    //     {
    //       "ao_enterprise_workflow_vessel_accounts": [
    //         {
    //           "account_id": "string",
    //           "creatable": true,
    //           "created_at": "2024-03-22T11:11:13.339Z",
    //           "deletable": true,
    //           "id": "string",
    //           "is_responsible": true,
    //           "readable": true,
    //           "updatable": true,
    //           "updated_at": "2024-03-22T11:11:13.339Z"
    //         }
    //       ],
    //       "ao_enterprise_workflow_vessel_departments": [
    //         {
    //           "created_at": "2024-03-22T11:11:13.339Z",
    //           "id": "string",
    //           "name": "string",
    //           "updated_at": "2024-03-22T11:11:13.339Z"
    //         }
    //       ],
    //       "created_at": "2024-03-22T11:11:13.339Z",
    //       "enterprise_vessel_id": "string",
    //       "id": "string",
    //       "updated_at": "2024-03-22T11:11:13.339Z"
    //     }
    //   ],
    //   "created_at": "2024-03-22T11:11:13.339Z",
    //   "id": "string",
    //   "updated_at": "2024-03-22T11:11:13.339Z"
    // }
  ], // ResponseEnterpriseOperationWorkflow[]
};

export default {
  isRegistered: false,
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  mutations: {
    SET_OPERATION_WORKFLOWS(state, data) {
      state.operationWorkflows = data;
    },

    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },
  actions: {
    /**
     * operation workflowsをstoreにセットする
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationWorkflows({ commit }) {
      const operationWorkflows = await operationWorkflowService.getOperationWorkflows();
      commit("SET_OPERATION_WORKFLOWS", operationWorkflows.data || []);
      operationLocalDbService.setOperationWorkflowsToLocalDB(
        operationWorkflows.data || []
      );
    },

    /**
     * operation workflows  を localDB から取得し storeにセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationWorkflowsFromLocalDB({ commit }) {
      const operationWorkflows = await operationLocalDbService.getOperationWorkflowsFromLocalDB();
      commit("SET_OPERATION_WORKFLOWS", operationWorkflows || []);
    },

    /**
     * operation workflows  を localDB から取得し storeにセットする
     * localDBにない場合はAPIから取得し store にセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationWorkflowsFromLocalDBAndAPI({ dispatch, getters }) {
      await dispatch("setOperationWorkflowsFromLocalDB");
      if (!getters.hasOperationWorkflows) {
        dispatch("setOperationWorkflows");
      }
    },

    /**
     * storeを初期値に戻す
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     */
    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },
  getters: {
    validOperationWorkflows: ({ operationWorkflows }) => {
      return operationWorkflowService.validOperationWorkflows(
        operationWorkflows
      );
    },

    hasOperationWorkflows: (_, { validOperationWorkflows }) => {
      return validOperationWorkflows.length > 0;
    },

    // {[key: AoEnterpriseWorkflowVesselId]: ResponseEnterpriseOperationWorkflow[]}
    // AoEnterpriseWorkflowVesselId : ResponseEnterpriseOperationWorkflow === 1 : n
    operationWorkflowMapByAoEnterpriseWorkflowVesselId: (
      _,
      { validOperationWorkflows }
    ) => {
      return validOperationWorkflows.reduce((acc, ow) => {
        ow.ao_enterprise_workflow_vessels.forEach(({ id }) => {
          acc[id] = ow;
        });
        return acc;
      }, {});
    },

    // ResponseEnterpriseOperationWorkflowVessel[] を返す
    operationWorkflowVessels: (_state, { validOperationWorkflows }) => {
      return operationWorkflowService.operationWorkflowVessels(
        validOperationWorkflows
      );
    },

    // ResponseOperationWorkflowVesselMap を返す
    operationWorkflowVesselMap: (_state, { operationWorkflowVessels }) => {
      return operationWorkflowService.operationWorkflowVesselMap(
        operationWorkflowVessels
      );
    },

    operationWorkflowVesselDepartments: (
      _state,
      { operationWorkflowVessels }
    ) => {
      return operationWorkflowService.operationWorkflowVesselDepartments(
        operationWorkflowVessels
      );
    },

    operationWorkflowVesselDepartmentMap: (
      _state,
      { operationWorkflowVesselDepartments }
    ) => {
      return operationWorkflowService.operationWorkflowVesselDepartmentMap(
        operationWorkflowVesselDepartments
      );
    },

    operationWorkflowVesselAccounts: (_state, { operationWorkflowVessels }) => {
      return operationWorkflowService.operationWorkflowVesselAccounts(
        operationWorkflowVessels
      );
    },

    operationWorkflowVesselAccountMap: (
      _state,
      { operationWorkflowVesselAccounts }
    ) => {
      return operationWorkflowService.operationWorkflowVesselAccountMap(
        operationWorkflowVesselAccounts
      );
    },
  },
};
